import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';
import { connect } from '../../../react-redux';
import * as scrollingActionCreators from '../../../actions/scrolling';
var connectToScrollingStore = function connectToScrollingStore(ComposedComponent) {
  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      scrollingActions: bindActionCreators(scrollingActionCreators, dispatch)
    };
  };
  var mapStateToProps = function mapStateToProps(state) {
    // TODO: change the name in state
    return {
      scrolledComponentKey: state.getIn(['scrolling', 'scrolledComponentKey']),
      scrollingFocus: state.getIn(['scrolling', 'scrollingFocus'])
    };
  };
  return connect(mapStateToProps, mapDispatchToProps, null, {
    withRef: true
  })(ComposedComponent);
};
var unconnectedMakeScrollable = function unconnectedMakeScrollable(ComposedComponent) {
  var _WithScrollableItems;
  return _WithScrollableItems = /*#__PURE__*/function (_Component) {
    function WithScrollableItems(props) {
      var _this;
      _classCallCheck(this, WithScrollableItems);
      _this = _callSuper(this, WithScrollableItems, [props]);
      _defineProperty(_this, "composedRef", function (node) {
        _this._composed = node;
      });
      _this._composed = null;
      return _this;
    }
    _inherits(WithScrollableItems, _Component);
    return _createClass(WithScrollableItems, [{
      key: "composedProps",
      get: function get() {
        var _this2 = this;
        // We want the props that are in CC.propTypes, and the passthrough props,
        // which are in neither our nor CC's propTypes
        return Object.assign.apply(Object, [{}].concat(_toConsumableArray(Object.keys(this.props).filter(function (name) {
          return ComposedComponent.propTypes && ComposedComponent.propTypes[name] || !_this2.constructor.propTypes[name];
        }).map(function (name) {
          return _defineProperty({}, name, _this2.props[name]);
        }))));
      }
    }, {
      key: "isScrolled",
      value: function isScrolled() {
        return this.props.scrollKey === this.props.scrolledComponentKey;
      }
    }, {
      key: "scrollIntoView",
      value: function scrollIntoView() {
        var scrollingFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var node = ReactDOM.findDOMNode(this);
        node.scrollIntoView();
        if (scrollingFocus) node.focus(); // Focus on the item once scrolled into view
      }
    }, {
      key: "setFocus",
      value: function setFocus() {
        var node = ReactDOM.findDOMNode(this);
        node && node.focus();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.shouldFocusOnMount) {
          this.setFocus();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        var _this$props = this.props,
          scrolledComponentKey = _this$props.scrolledComponentKey,
          scrollingFocus = _this$props.scrollingFocus,
          scrollKey = _this$props.scrollKey,
          scrollingActions = _this$props.scrollingActions;
        if (prevProps.scrolledComponentKey !== scrolledComponentKey && scrolledComponentKey && scrollKey && scrolledComponentKey === scrollKey) {
          this.scrollIntoView(scrollingFocus);
          scrollingActions.clearsScrolledComponentKey();
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(ComposedComponent, Object.assign({}, this.composedProps, {
          ref: this.composedRef
        }), this.props.children);
      }
    }]);
  }(Component), _defineProperty(_WithScrollableItems, "propTypes", _objectSpread(_objectSpread({}, ComposedComponent.propTypes || {}), {}, {
    scrollKey: PropTypes.string,
    scrolledComponentKey: PropTypes.string,
    scrollingFocus: PropTypes.bool,
    scrollingActions: PropTypes.shape({
      clearsScrolledComponentKey: PropTypes.func.isRequired
    }).isRequired,
    shouldFocusOnMount: PropTypes.bool
  })), _defineProperty(_WithScrollableItems, "defaultProps", {
    scrollKey: '',
    scrolledComponentKey: '',
    scrollingFocus: false,
    shouldFocusOnMount: false
  }), _WithScrollableItems;
};
export var unconnectedExtension = function unconnectedExtension(givenComponent) {
  return unconnectedMakeScrollable(givenComponent);
};
export var makeScrollable = function makeScrollable(givenComponent) {
  return connectToScrollingStore(unconnectedExtension(givenComponent));
};
export default makeScrollable;